import { Navigate, useLocation, useParams } from 'react-router';

/** Old bookmarks under `/mindtime/wazu/*` → `/mindtime/security/*`. */
export const LegacyWazuPathRedirect = (): JSX.Element => {
  const { pathname, search } = useLocation();
  const nextPath = pathname.replace(/^\/mindtime\/wazu/, '/mindtime/security');
  return <Navigate to={`${nextPath}${search}`} replace />;
};

export const SecurityLegacyEndpointRedirect = (): JSX.Element => {
  const { systemWazuhAgentId } = useParams<{ systemWazuhAgentId: string }>();

  if (!systemWazuhAgentId) {
    return <Navigate to="/mindtime/security/edr/endpoints" replace />;
  }

  return (
    <Navigate
      to={`/mindtime/security/edr/endpoints/${encodeURIComponent(systemWazuhAgentId)}`}
      replace
    />
  );
};
